import { Grid, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import VerificationModal from "../../components/modals/verificationModal";
import LaddaButton from "../../components/buttons/laddaButton";
import FormCalendar from "../../components/calendar/formCalendar";
import {
  callApiAsync,
  getStakeholdersDates,
  saveStakeholdersDates
} from "../../services/apiService";
import { isInterestedPartiesModuleAdmin } from "../../utils/interestedPartiesPermissions";

const DateBanners = ({ rowData }) => {
  const [bannerData, setBannerData] = useState({});
  const [openVerification, setOpenVerification] = useState(false);

  const validationSchema = {};

  const userData = useSelector((state) => state.userData.userData);
  const isModuleAdmin = isInterestedPartiesModuleAdmin(userData?.roleList);

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      creationDate: null,
      publicationDate: null,
      reviewDate: null,
      scheduledUpdateDate: null
    }
  });

  const getDates = async () => {
    await callApiAsync(
      () => getStakeholdersDates(),
      (data) => {
        setBannerData(data);
      }
    );
  };

  const createDashboard = async (data) => {
    if (!isModuleAdmin) return;
    callApiAsync(
      () => saveStakeholdersDates({ ...data, user_id: userData?.id }),
      () => {
        console.log("Fechas guardadas");
      }
    );
  };

  const handleOpenVerification = () => setOpenVerification(true);
  const handleCloseVerification = () => setOpenVerification(false);

  function parseLocalDateOnly(dateStr) {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  }

  const setFormValues = (data) => {
    if (data) {
      setValue("creationDate", parseLocalDateOnly(data.creationDate));
      setValue("publicationDate", parseLocalDateOnly(data.publicationDate));
      setValue("reviewDate", parseLocalDateOnly(data.reviewDate));
      setValue(
        "scheduledUpdateDate",
        parseLocalDateOnly(data.scheduledUpdateDate)
      );
    }
  };

  const handleSaveBanner = () => {
    const formData = getValues();
    createDashboard(formData);
    handleCloseVerification();
  };

  useEffect(() => {
    if (bannerData) {
      setFormValues(bannerData);
    }
  }, [bannerData]);

  useEffect(() => {
    getDates();
  }, []);

  return (
    <div className="managmentBanner-mini bm-30">
      <form>
        <Grid container rowSpacing={2} sx={{ alignItems: "center" }}>
          <Grid item xs={12} md={2}>
            <p className="detail-label m-0">
              Fecha de elaboración del documento:
            </p>
          </Grid>
          <Grid item xs={12} md={10}>
            <FormCalendar
              name="creationDate"
              control={control}
              label=""
              defaultValue={null}
              formLabel=""
              margin="0"
              disabled={!isModuleAdmin}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <p className="detail-label m-0">Fecha de publicación oficial:</p>
          </Grid>
          <Grid item xs={12} md={10}>
            <FormCalendar
              name="publicationDate"
              control={control}
              label=""
              defaultValue={null}
              formLabel=""
              margin="0"
              disabled={!isModuleAdmin}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <p className="detail-label m-0">Fecha de revisión:</p>
          </Grid>
          <Grid item xs={12} md={10}>
            <FormCalendar
              name="reviewDate"
              control={control}
              label=""
              defaultValue={null}
              formLabel=""
              margin="0"
              disabled={!isModuleAdmin}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <p className="detail-label m-0">
              Fecha de revisión o actualización programada:
            </p>
          </Grid>
          <Grid item xs={12} md={10}>
            <FormCalendar
              name="scheduledUpdateDate"
              control={control}
              label=""
              defaultValue={null}
              formLabel=""
              margin="0"
              disabled={!isModuleAdmin}
            />
          </Grid>
        </Grid>
        {isModuleAdmin && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
              flexDirection: "column"
            }}
          >
            <LaddaButton
              width="200px"
              variant="contained"
              onClick={handleOpenVerification}
            >
              <div className="HContainer align-center">
                <p className="button_text">Guardar</p>
              </div>
            </LaddaButton>
          </div>
        )}
      </form>

      <VerificationModal
        open={openVerification}
        handleClose={handleCloseVerification}
        alertText={<b>¿Estás seguro de guardar los cambios?</b>}
        onConfirm={handleSaveBanner}
      />
    </div>
  );
};

export default DateBanners;
